import type { ReactNode } from "react";

// Status palette — small uppercase pill anchored to the portal's `chip`
// class. Each tone slots into a brand-aligned colour pair. `slate` is kept
// as an alias of `grey` so older call sites don't break.
type Tone = "green" | "red" | "yellow" | "blue" | "grey" | "slate";

const toneClasses: Record<Tone, string> = {
  green: "bg-green-100 text-green-800",
  red: "bg-red-100 text-red-800",
  yellow: "bg-yellow-100 text-yellow-800",
  blue: "bg-blue-light text-blue-dark",
  grey: "bg-line text-ink-soft",
  slate: "bg-line text-ink-soft",
};

type Props = {
  tone?: Tone;
  children: ReactNode;
  title?: string;
  className?: string;
};

export function StatusBadge({
  tone = "grey",
  children,
  title,
  className = "",
}: Props) {
  return (
    <span
      title={title}
      className={`chip ${toneClasses[tone]} ${className}`.trim()}
    >
      {children}
    </span>
  );
}

type DotProps = {
  tone: Tone;
  title?: string;
};

const dotColours: Record<Tone, string> = {
  green: "bg-green-500",
  red: "bg-red-500",
  yellow: "bg-yellow-500",
  blue: "bg-blue",
  grey: "bg-ink-soft/40",
  slate: "bg-ink-soft/40",
};

export function StatusDot({ tone, title }: DotProps) {
  return (
    <span
      aria-hidden="true"
      title={title}
      className={`inline-block h-2.5 w-2.5 rounded-full ${dotColours[tone]}`}
    />
  );
}
